// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"239":"8c554a61","453":"9ddf26ad","455":"04b3f169","977":"6c00fa4d"}[chunkId] + ".chunk.js";
};